@if (canShow) {
  <button
    mat-menu-item
    (click)="onUpload()"
    >
    <mat-icon color="success">file_upload</mat-icon>
    <span>Upload Products</span>
  </button>
}
